import { datadogRum } from '@datadog/browser-rum'

export default {
  rum: {
    async init() {
      try {
        datadogRum.init({
          applicationId: '3db266d5-375c-4fec-9cd1-a66308d7f3a5',
          clientToken: 'pubdd2b33d990985ce283b1bced8e6c5404',
          service: 'default',
          site: 'datadoghq.eu',
          env: process.env.NODE_ENV,
          version: process.env.REACT_APP_VERSION,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 20,
          defaultPrivacyLevel: 'mask-user-input'
        })

        console.log(
          `Datadog service - frontend ${process.env.REACT_APP_VERSION} ${process.env.NODE_ENV} RUM initialised!`
        )
      } catch (err: any) {
        console.error(`Datadog service - ${err.message}`)
      }
    }
  }
}
